var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"round-button",class:[_vm.mode],on:{"click":_vm.onClick}},[_c('p',{staticClass:"body-semi-bold white"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }